import { PartinerFormComponent } from './partiner-form/partiner-form.component';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { PartinersComponent } from './partiners.component';
import { PartinersRoutingModule } from './partiners-routing.module';
import { PartinersDetailComponent } from './partiners-detail/partiners-detail.component';

@NgModule({
  declarations: [PartinersComponent, PartinerFormComponent, PartinersDetailComponent],
  imports: [
    SharedModule,
    PartinersRoutingModule
  ]
})
export class PartinersModule { }
